var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGridView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 7.60521V3.82187C18.3333 2.64688 17.8 2.17188 16.475 2.17188H13.1083C11.7833 2.17188 11.25 2.64688 11.25 3.82187V7.59688C11.25 8.78021 11.7833 9.24687 13.1083 9.24687H16.475C17.8 9.25521 18.3333 8.78021 18.3333 7.60521Z",
    stroke: "#E2E3E3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 16.975V13.6083C18.3333 12.2833 17.8 11.75 16.475 11.75H13.1083C11.7833 11.75 11.25 12.2833 11.25 13.6083V16.975C11.25 18.3 11.7833 18.8333 13.1083 18.8333H16.475C17.8 18.8333 18.3333 18.3 18.3333 16.975Z",
    stroke: "#E2E3E3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7474 7.60521V3.82187C8.7474 2.64688 8.21406 2.17188 6.88906 2.17188H3.5224C2.1974 2.17188 1.66406 2.64688 1.66406 3.82187V7.59688C1.66406 8.78021 2.1974 9.24687 3.5224 9.24687H6.88906C8.21406 9.25521 8.7474 8.78021 8.7474 7.60521Z",
    stroke: "#E2E3E3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7474 16.975V13.6083C8.7474 12.2833 8.21406 11.75 6.88906 11.75H3.5224C2.1974 11.75 1.66406 12.2833 1.66406 13.6083V16.975C1.66406 18.3 2.1974 18.8333 3.5224 18.8333H6.88906C8.21406 18.8333 8.7474 18.3 8.7474 16.975Z",
    stroke: "#E2E3E3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGridView);
export default __webpack_public_path__ + "static/media/userGrid-view.01a0c7b2645688fe5199cf30548049a0.svg";
export { ForwardRef as ReactComponent };